const Err404 = () =>{
  return(
    <div>
        <h1>404</h1>
      No results found 
    </div>
  )
}

export default Err404;